import { IQueryClassDependency } from '@kurtosys/types/dependencies/IQueryClassDependency.js';
import { ITransformClassDependency } from '@kurtosys/types/dependencies/ITransformClassDependency.js';
import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';
import { IQueryOptionsCollectionBase } from '@kurtosys/types/query/options/IQueryOptionsCollectionBase.js';

import { helpers } from '../../../common/index.js';
import { getIndex } from '../../queryUtils/getIndex.js';
import { getItem } from '../../queryUtils/getItem.js';

import { BaseEntityQuery } from './BaseEntityQuery.js';

export abstract class BaseCollectionQuery<
	TChildOptions extends IQueryOptionsCollectionBase,
> extends BaseEntityQuery<TChildOptions> {
	constructor(
		public dependencies: IQueryClassDependency & ITransformClassDependency,
		public queryOptions: IQueryOptions,
		public translationHelper?: helpers.TranslationHelper,
	) {
		super(dependencies, queryOptions, translationHelper);
	}
	getItem(executionOptions: IExecutionOptions, unsortedCollection: any[]): any {
		const { sort, startIndex, endIndex, index } = this.options;
		const { culture } = executionOptions;
		const collection = this.applySort(unsortedCollection, sort, culture, executionOptions.inputs);
		return getItem({
			collection,
			startIndex,
			endIndex,
			index,
		});
	}
	/**
	 * Determine collection index, based on configurable index,
	 * which could be provided as a negative value.
	 *
	 * @param targetIndex
	 * @param collection
	 * @returns valid collection index. -1 will be returned if the target index is invalid
	 */
	getIndex(targetIndex: number, collection: any[]): number {
		return getIndex({
			collection,
			targetIndex,
		});
	}
}
